export const FILE_TYPE_REGEX = /^image\/(jpeg|png)$/;
export const IMAGE_TYPE_MESSAGE = "Invalid file type. Please select a JPEG or PNG file.";
